exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "svg path[data-v-23053100],svg rect[data-v-23053100]{fill:inherit;stroke:inherit;stroke-width:inherit}", ""]);

// exports
